export enum AlertReviewStatus {
    //// Dummy Values
    Open, Closed
}

